import { a as isInBrowser, i as isInNode } from './index-01657716.js';

function base64encode(str = '') {
    if (isInBrowser()) {
        return btoa(unescape(encodeURIComponent(str)));
    }
    else if (isInNode()) {
        return Buffer.from(str).toString('base64');
    }
    else {
        throw new Error('current runtime is neither browser nor nodejs');
    }
}
function getQualityConfig(quality) {
    if (quality < 1 || quality > 100) {
        throw new RangeError('invalid quality [1, 100]');
    }
    return `quality,Q_${quality}`;
}
function getResizeConfig(params) {
    const args = [];
    const { maxWidth, maxHeight } = params;
    if (typeof maxWidth !== 'undefined') {
        if (maxWidth < 1 || maxWidth > 4096) {
            throw new RangeError('invalid maxWidth [1, 4096]');
        }
        args.push(`w_${maxWidth}`);
    }
    if (typeof maxHeight !== 'undefined') {
        if (maxHeight < 1 || maxHeight > 4096) {
            throw new RangeError('invalid maxHeight [1, 4096]');
        }
        args.push(`h_${maxHeight}`);
    }
    if (args.length === 0) {
        return '';
    }
    return `resize,${args.join(',')}`;
}
function getWatermarkConfig(params) {
    if (params.text === '' || params.text === null || typeof params.text === 'undefined') {
        return '';
    }
    const textConf = `text_${base64encode(params.text)}`;
    return `watermark,${textConf},size_50,color_efefef,fill_1,shadow_5,g_center,rotate_330`;
}
function addImgUrlSuffix(imgUrl, config) {
    let suffixes = [];
    if (config.quality) {
        suffixes.push(getQualityConfig(config.quality));
    }
    if (config.resize) {
        suffixes.push(getResizeConfig(config.resize));
    }
    if (config.watermark) {
        suffixes.push(getWatermarkConfig(config.watermark));
    }
    if (suffixes.length === 0) {
        return imgUrl;
    }
    return `${imgUrl}?x-image-process=image/${suffixes.join('/')}`;
}

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    addImgUrlSuffix: addImgUrlSuffix
});

export { addImgUrlSuffix as a, index as i };
//# sourceMappingURL=index-d9bd0e05.js.map
